import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {  ICompanyProductModel, ICompanyProductList, IProductActiveMarketinfo } from 'src/app/Shared/Interfaces/Iproduct';
import { IProductFilterOption } from 'src/app/Shared/Interfaces/Ifilter';
import { IUserActiveMarketinfo, IUserModel } from 'src/app/Shared/models/AdminUserModel';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class AdminUserService {
    private baseURL: string; 
     constructor(private http: HttpClient) {
          this.baseURL = environment.apiBaseUrl;
    }
 
  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

   GetAllUsers(): Observable<any> {
    return this.http.get<any>(
        `${this.baseURL}/AdminUser/GetAllUserList`,
        { observe: 'response' })
        .pipe(
          map(res => {
           
            const result = res.body as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }
    

   
   GetUserAssignedMarkets(Id: number): Observable<any> {
    
    return this.http.get<any>(
        `${this.baseURL}/AdminUser/GetAllActiveMarketforUser?Id=${Id}`,
        { observe: 'response' })
        .pipe(
          map(res => {
            const result = res.body as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }

   GetUsersAssignedToMarket(obj : any): Observable<any> {
    
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/AdminUser/GetAllUserListForMarket`;
        return this.http.post<any>(url, obj, options)
          .pipe(
            map(res => {
              const response = res as any[];
              return response;
            }),
            catchError(this.handleError)
          );
   }


   SaveUser(user: IUserModel): Observable<any> {
    
   const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/AdminUser/SaveUser`;
        return this.http.post<any>(url, user, options)
          .pipe(
            map(res => {
              const response = res as any[];
              return response;
            }),
            catchError(this.handleError)
          );
   }

   GetUserById(Id: number): Observable<any> {
    return this.http.get<any>(
        `${this.baseURL}/AdminUser/GetUserById?Id=${Id}`,
        
        { observe: 'response' })
        .pipe(
          map(res => {
            const result = res as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }


 
   UpdateUser(CompanyProduct: ICompanyProductModel): Observable<any> {
    return this.http.post<any>(
        `${this.baseURL}/AdminUser/SaveUser`,
        CompanyProduct,
        { observe: 'response' })
        .pipe(
          map(res => {
            const result = res as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }

   DeleteUserById(Id: number): Observable<any> {
    return this.http.get<any>(
        `${this.baseURL}/AdminUser/DeleteUser?Id=${Id}`,
        
        { observe: 'response' })
        .pipe(
          map(res => {
            const result = res as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }


   CheckUserTransaction(Id: number): Observable<any> {
    return this.http.get<any>(
        `${this.baseURL}/AdminUser/CheckUserTransaction?Id=${Id}`,
        
        { observe: 'response' })
        .pipe(
          map(res => {
            const result = res.body as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }

      
   UpdateOrSaveAssignUserToMarket(AssignUser: IUserActiveMarketinfo): Observable<any> {
    
         const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
         const url = `${this.baseURL}/AdminUser/UpdateOrSaveAssignedUser`;
         return this.http.post<any>(url, AssignUser, options)
           .pipe(
             map(res => {
               const response = res as any[];
               return response;
             }),
             catchError(this.handleError)
           );
    }


    
   CheckUserNameExistOrNot(validate): Observable<any> {
    return this.http.post<any>(
        `${this.baseURL}/AdminUser/CheckUserNameExistOrNot`,
        validate,
        { observe: 'response' })
        .pipe(
          map(res => {
            const result = res as any;
            return result;
          }),
          catchError(this.handleError)
        );
   }
    
   GetAllUserGroup(): Observable<any> {
    
    return this.http.get<any>(
      `${this.baseURL}/admin/UserGroup/GetAllUserGroups`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body;
         
        }),
        catchError(this.handleError)
      );
   }

   ForgotPassword(email): Observable<any> {
    
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
         const url = `${this.baseURL}/user/ForgotPassword`
         return this.http.post<any>(url, {email}, options)
           .pipe(
             map(res => {
               const response = res as any[];
               return response;
             }),
             catchError(this.handleError)
           );
    }

    UpdatePasscode(user): Observable<any> {
    
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
           const url = `${this.baseURL}/AdminUser/UpdatePasscode`;
           return this.http.post<any>(url, user, options)
             .pipe(
               map(res => {
                 const response = res as any[];
                 return response;
               }),
               catchError(this.handleError)
             );
      }

    GetUserShopperTicketInfo(marketTicketinfo): Observable<any> {
  
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
          const url = `${this.baseURL}/AdminUser/GetUserShopperTicketInfo`;
          return this.http.post<any>(url, marketTicketinfo, options)
            .pipe(
              map(res => {
                const response = res as any[];
                return response;
              }),
              catchError(this.handleError)
            );
  }

  GetUserFavoriteMenu(): Observable<any> {

    return this.http.get<any>(
      `${this.baseURL}/AdminUser/GetUserFavoriteMenu`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body;

        }),
        catchError(this.handleError)
      );
  }

  SaveUserFavoriteMenu(model: { MenuIds: number[] }): Observable<any> {

    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/AdminUser/SaveUserFavoriteMenu`;
    return this.http.post<any>(url, model, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

}
